import { StrictMode } from "react";
import * as ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

import App from "./app/app";
import { ErrorBoundary } from "@sentry/react";
import { AnalyticsProvider } from "./features/analytics";
import { DebugPanel } from "@/frontend/components/DebugPanel/DebugPanel";
import { ErrorScreen } from "./shared/ui/ErrorScreen/ErrorScreen";

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);
const queryClient = new QueryClient();

root.render(
  <StrictMode>
    <ErrorBoundary
      fallback={<div>Query Error</div>}
      beforeCapture={(scope) => {
        scope.setTag("location", "query-client-provider");
      }}
    >
      <QueryClientProvider client={queryClient}>
        <BrowserRouter>
          <ErrorBoundary
            fallback={<ErrorScreen />}
            beforeCapture={(scope) => {
              scope.setTag("location", "app");
            }}
          >
            <AnalyticsProvider>
              <App />
              {import.meta.env.VITE_ENABLE_DEBUG_PANEL === "true" && <DebugPanel />}
            </AnalyticsProvider>
          </ErrorBoundary>
        </BrowserRouter>
      </QueryClientProvider>
    </ErrorBoundary>
  </StrictMode>
);
